import React, { Component } from 'react';
import moment from 'moment';

import DateRangePlain from '../DateRange/DateRangePlain';

class FilterDateRange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            periodStart: '',
            periodEnd: ''
        }
    }

    getDateRange = (from, to) => {
        this.setState({
            periodStart: from,
            periodEnd: to
        })
        this.props.getDateRange(from, to);
    }

    render() {
        return (
            <div className="flex justify-center flex-col">
                {
                    this.state.periodStart === '' && this.state.periodEnd === '' ?
                        <div className="text-center mt-2">
                            <div className="font-medium">Pilih Tanggal</div>
                        </div>
                        :
                        <div className="text-center mt-2">
                            <div className="font-medium">{moment(this.state.periodStart).format('DD/MM/YYYY')} - {moment(this.state.periodEnd).format('DD/MM/YYYY')}</div>
                        </div>
                }
                <DateRangePlain
                    getDateRange={this.getDateRange}
                />
            </div>
        );
    }
}

export default FilterDateRange;